interface SourceProps {
  sources: [
    {
      media: string
      srcSet: string
    }
  ]
}

const useImageDistinguisher = ({ sources }: SourceProps) => {
  const images = {
    mobileImage: '',
    desktopImage: '',
  }

  sources?.forEach((source) => {
    if (source.media === '(max-width: 48em)') {
      images.mobileImage = source.srcSet
    }

    if (source.media === '(min-width: 48em)') {
      images.desktopImage = source.srcSet
    }
  })

  return images
}

export default useImageDistinguisher
